module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "MaintenanceSchedule_EmptyIcon.c5ed855a.png";